module.exports = __webpack_public_path__ + "static/media/16.f2b96a0f.png";